// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"node_modules_html2canvas_dist_html2canvas_js":1,"node_modules_dompurify_dist_purify_es_mjs":1,"node_modules_canvg_lib_index_es_js":1}[chunkId]) return "web/js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};